<template>
  <div class="history-changes">
    <div class="table-overflow">
      <table class="table-cell-fix">
        <thead>
          <tr>
            <td class="td-num">№</td>
            <td>{{ $t('Действие') }}</td>
            <td class="td-date-time">{{ $t('Дата, время') }}</td>
            <td>{{ $t('Пользователь') }}</td>
            <td class="td-action">{{ $t('Действия') }}</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(history, index) in npaHistoryChanges" :key="history.h_id">
            <td class="td-num"> {{ index+1 }}</td>
            <td>{{ $t(history.h_description) }}</td>
            <td class="td-date-time">
              {{ new Date(history.h_date) | dateFormat('DD.MM.YYYY HH:mm') }}
            </td>
            <td>{{ history.u_email }}</td>
            <td>
              <NpaHistoryChangesView :historyId="history.h_id" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import NpaHistoryChangesView from "@/components/npa/NpaHistoryChangesView";

export default {
  components: {
    NpaHistoryChangesView
  },
  props: {
    npaHistoryChanges: Array
  }
}
</script>
